import React, { useEffect, useState } from 'react';
import { allGroupsSelector, allBrandsSelector } from '../../propertySlice';
import { useSelector } from 'react-redux';
import { GROUP_EDIT } from '../../../../constants/PropertyConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_GROUPS,
} from '../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../shared/detail-view-layout/Detail-View-Layout';

const GroupView = (props) => {
  const { group, onViewToggle, toggleDrawer, permissions } = props;
  const [selectedGroup, setSelectedGroup] = useState(group);
  const originalGroups = useSelector(allGroupsSelector);
  const originalBrands = useSelector(allBrandsSelector);

  useEffect(() => {
    const groupObj = {
      ...originalGroups.find((tempGroup) => tempGroup.id === group.id),
    };
    groupObj['brands'] = originalBrands.filter((b) => b.groupId === group.id);
    setSelectedGroup(groupObj);
  }, [originalGroups]);

  const getBrands = (brands) => {
    let brandList = brands.map((brand) => {
      return brand.name;
    });
    return brandList.sort().join(', ');
  };

  const onClickEdit = (event) => {
    toggleDrawer(GROUP_EDIT, true, selectedGroup);
  };

  const renderScreen = () => {
    return (
      <div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12 mb-4'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Hotel Group Name</div>
            <div className='details-value'>{selectedGroup.name}</div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Hotel Group Code</div>
            <div className='details-value'>{selectedGroup.code}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Group Email Id</div>
            <div className='details-value'>
              {selectedGroup?.customSenderEmail ? selectedGroup?.customSenderEmail : '---'}
            </div>
          </div>

          <div className='col-md-4'>
            <div className='details-label'>Digital Key</div>
            <div className='details-value'>
              {selectedGroup?.firebaseToken
                ? '######' + selectedGroup?.firebaseToken.slice(-4)
                : '---'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>
              {selectedGroup.description ? selectedGroup.description : '---'}
            </div>
          </div>
        </div>
        {selectedGroup.brands && (
          <div className='row mx-4 mt-4'>
            <div className='col-md-4'>
              <div className='details-label'>No.of Brands</div>
              <div className='details-value'>{selectedGroup.brands.length}</div>
            </div>
            <div className='col-md-8'>
              <div className='details-label'>Brand names</div>
              <div className='details-value'>
                {selectedGroup.brands.length ? getBrands(selectedGroup.brands) : '---'}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {selectedGroup && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          title={selectedGroup.name}
          createdUserId={selectedGroup.createdBy}
          isEditable={permissions[RBAC_TYPE_GROUPS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
        />
      )}
    </>
  );
};
export default GroupView;
